import React from 'react';
import AddonModal from './AddonModal';
import PostTrackingPayment from '../../../settings/components/PostTrackingPayment';
import AddonSuccessModal from './AddonSuccessModal';

const GetSocialListeningModal = ({ currentOpenModal, setCurrentModal }) => {
  if (currentOpenModal === 1) {
    return (
      <AddonModal
        show={currentOpenModal === 1}
        onClose={() => setCurrentModal(0)}
        getOnModalClick={() => setCurrentModal(2)}
      />
    );
  }

  if (currentOpenModal === 2) {
    return (
      <PostTrackingPayment
        isOpen={currentOpenModal === 2}
        onClose={() => setCurrentModal(0)}
        onPaymentSuccess={() => setCurrentModal(3)}
      />
    );
  }

  if (currentOpenModal === 3) {
    return (
      <AddonSuccessModal
        show={currentOpenModal === 3}
        onClose={() => setCurrentModal(0)}
      />
    );
  }

  return <></>;
};

export default GetSocialListeningModal;
